import axios from 'axios'

export const getIP = async (): Promise<string> => {
    const res = await axios.get('https://api.ipify.org/?format=json')
    return res.data.ip || ''
}
